export default __webpack_public_path__ + "static/media/owl.6d59e011.png";